<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
    }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
    }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">CS Case</h3>
      <div class="action_bar mb-3">
        <b-button class="btn-action-lg" size="sm" variant="info" :to="{ name: 'cs_issue_add' }">Create CS Case</b-button>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.status_selected" :options="search_status_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.category_selected" :options="search_category_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="Order#"
              v-model="search_criteria.tracking_number" @keyup.enter="onSearch"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2" class="pr-1">
            <!-- <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Created By"
              v-model="search_criteria.created_by"
             @keyup.enter="onSearch"></b-form-input> -->
            <b-form-select size="sm" v-model="search_criteria.created_by" :options="search_user_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.start_at"></b-form-input>
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.end_at"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="exportCSV('by_case')">Export (By
              Case)</b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="exportCSV('by_item')">Export (By
              Item)</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <!-- <strong>Outstanding:</strong> -->
          <b-row>
            <b-col cols="12" sm="12" md="2">
              <div class="cusor_pointer">
                <strong> Response Status </strong>
                <div class="row-status_cnt">
                  <div style="width: 350px">Pending GOLS Response</div>
                  <div style="text-wrap: nowrap;">
                    <span class="dot_gols"></span>
                    <span>
                      {{ count_client }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt">
                  <div style="width: 350px">Pending Client Response</div>
                  <div style="text-wrap: nowrap;">
                    <span class="dot_client"></span>
                    <span>
                      {{ count_gols }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT" v-if="items && items.length > 0"></b-pagination>

      <h4 v-if="items && items.length == 0">
        No Records
      </h4>

      <cs-issue-card :key="item_index" v-for="(item, item_index) in items" :item="item" mode="edit"></cs-issue-card>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT" v-if="items && items.length > 0"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "id",
    label: "ID"
  },
  {
    key: "category",
    label: "Category"
  },
  {
    key: "tracking_number",
    label: "Tracking Number"
  },
  {
    key: "contents",
    label: "Contents"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "created_by",
    label: "Created By"
  },
  {
    key: "updated_by",
    label: "Updated By"
  },
  {
    key: "updated_at",
    label: "Updated At"
  },
  {
    key: "action",
    label: "Action"
  }
];

import CsIssue_Card from "../components/CsIssue_Card.vue";

export default {
  name: "CsIssues",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: false,
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_tracking_number: "",
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: 'Pending',
        category_selected: null,
        start_at: null,
        end_at: null,
        created_by: null
      },
      count_client: 0,
      count_gols: 0,
      search_category_options: [
        {
          value: null,
          text: "All Category"
        },
        {
          value: "Damage - Product Damage",
          text: "Damage - Product Damage"
        },
        {
          value: "Delivery - Late (Specified Timeframe)",
          text: "Delivery - Late (Specified Timeframe)"
        },
        {
          value: "Delivery - Late (Standard Timeframe)",
          text: "Delivery - Late (Standard Timeframe)"
        },
        {
          value: "Delivery - Other Service Issues",
          text: "Delivery - Other Service Issues"
        },
      ],
      search_status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        // {
        //   value: "Complete (N/A)",
        //   text: "Complete (N/A)"
        // },
        // {
        //   value: "Complete (Valid)",
        //   text: "Complete (Valid)"
        // },
        // {
        //   value: "Complete (Invalid)",
        //   text: "Complete (Invalid)"
        // },
        {
          value: "Complete",
          text: "Complete"
        },
        {
          value: "Cancel",
          text: "Cancel"
        }
      ],
      search_user_options: [
        {
          value: null,
          text: "All Users"
        },
        {
          value: "GOLS",
          text: "GOLS"
        },
        {
          value: "Client",
          text: "Client"
        },
      ],
      status_options: [
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "Complete (N/A)",
          text: "Complete (N/A)"
        },
        {
          value: "Complete (Valid)",
          text: "Complete (Valid)"
        },
        {
          value: "Complete (Invalid)",
          text: "Complete (Invalid)"
        },
        {
          value: "Cancel",
          text: "Cancel"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: ""
    };
  },
  async created() {
    await this.getCsIssues();
    // await this.getYLUsers();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    async onChangeCsStatus(event, item) {
      console.log(event);
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_update_status.php",
        data: {
          cs_issue_id: item.id,
          status: event,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.getCsIssues();
    },
    async replyCsIssue(item) {
      if (!item.reply_content || item.reply_content == "") {
        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_reply.php",
        data: {
          cs_issue_id: item.id,
          content: item.reply_content,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.getCsIssues();
    },

    exportCSV(export_mode) {
      let export_url = process.env.VUE_APP_API_HOST + "/cs_issue_export.php?";
      export_url += "&tracking_number=" + this.search_criteria.tracking_number;
      export_url += "&status_selected=" + this.search_criteria.status_selected;
      export_url +=
        "&category_selected=" + this.search_criteria.category_selected;
      export_url += "&start_at=" + this.search_criteria.start_at;
      export_url += "&end_at=" + this.search_criteria.end_at;
      export_url += "&export_mode=" + export_mode;

      export_url = encodeURI(export_url);

      console.log(export_url);

      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD HH:mm");
      } else {
        return "/";
      }
    },

    async getCsIssues() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        }
      });
      this.items = response.data.cs_issues;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();

      this.count_client = response.data.count_client;
      this.count_gols = response.data.count_gols;
    },

    async getYLUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          account_type: 'young_living'
        }
      });
      // this.yl_users = response.data.users;
      this.search_user_options = [{
        value: null,
        text: "All Users"
      },];
      for (let i in response.data.users) {
        let tmp_user = response.data.users[i];
        this.search_user_options.push({
          value: tmp_user.name,
          text: tmp_user.name,
        })
      }
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getCsIssues();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getCsIssues();
    },

    goToTrackingDetail(item) {
      console.log(item);
      this.$router.push({
        name: "tracking_detail",
        params: { id: item.tracking_id }
      });
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.tracking_url {
  cursor: pointer;
  text-decoration: underline;
}

.status-Complete {
  border-top: 5px solid green;
}

.status-Pending {
  border-top: 5px solid #f2e64b;
}

.status-Cancel {
  border-top: 5px solid #ff0000;
}

.row-status_cnt {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/CsIssues.vue